export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("Vue3Lottie");
});
